import { createContext, useContext } from 'react';

/**
 * @typedef {object} ModalContext
 * @property {string | null} activeModalId
 * @property {React.Dispatch<React.SetStateAction<string | null>>} setActiveModalId
 */

/** @type {React.Context<ModalContext>} */
// @ts-ignore
export const ModalContext = createContext(null);

export const useModalContext = () => useContext(ModalContext);

export const modalId = {
  filters: 'filters',
};
